import { render, staticRenderFns } from "./responsibleProfile.vue?vue&type=template&id=caa03256"
import script from "./responsibleProfile.vue?vue&type=script&lang=js"
export * from "./responsibleProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports